export default {
  computed: {
    userIsLoggedIn () {
      return this.$store.state.headerAuth?.userIsLoggedIn ?? false
    }
  },
}
